import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { saveAs } from 'file-saver';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { getDocuments, postEventApplication } from '../../ApiServices/Api';
import Loader from '../../Components/Loaders';
import KenDocumentUpload from '../KenDocumentUpload';
import KenStepperFooter from './Components/KenStepperFooter/index';
import ErrorIcon from '@mui/icons-material/Error';
import AttachFileIcon from '@mui/icons-material/AttachFile';

export default function DocumentUpload(props) {
  const { applicationState, applicationDispatch } = props;
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [pageLoader, setPageLoader] = useState(false);
  const [flag, setFlag] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const [uploadData, setUploadData] = useState(applicationState?.applicationData?.attachments);

  useEffect(() => {
    if (applicationState?.applicationData?.attachments) {
      const uploadDataCopy = [...uploadData];
      applicationState?.applicationData?.attachments?.forEach((el) => {
        let index = uploadDataCopy.findIndex((elem) => elem.title === el.title);
        if (index > -1) {
          uploadDataCopy[index] = { ...uploadDataCopy[index], ...el };
        }
      });
      setUploadData([...uploadDataCopy]);
      setPageLoader(false);
    }
  }, [flag]);

  const handleDownload = (id, fileType, fileName) => {
    setPageLoader(true);
    getDocuments(id)
      .then((res) => {
        if (res?.status === 'true') {
          setPageLoader(false);
          let file = convertBase64ToFile(res?.result?.data, fileName, fileType);
          saveAs(file, fileName);
        }
      })
      .catch((err) => {
        console.log(err);
        setPageLoader(false);
      });
  };

  const convertBase64ToFile = (base64String, fileName, fileType) => {
    let bstr = atob(base64String);
    let n = bstr.length;
    let uint8Array = new Uint8Array(n);
    while (n--) {
      uint8Array[n] = bstr.charCodeAt(n);
    }
    let file = new File([uint8Array], fileName, { type: fileType });
    return file;
  };

  const handlePrev = () => {
    setPageLoader(true);
    applicationDispatch({ type: 'prevStep' });
    setPageLoader(false);
  };

  const handleNext = () => {
    setPageLoader(true);
    let flagFalse = 0;
    if (uploadData[0]?.Submitted_File_Id__c) {
      uploadData.forEach((el) => {
        if (el.required === true) {
          if (!el.contentDocumentId) {
            flagFalse++;
          }
        }
      });
    } else {
      setPageLoader(false);
      return enqueueSnackbar('Please Upload Pitch Deck', { variant: 'error' });
    }

    if (flagFalse === 0) {
      applicationDispatch({ type: 'nextStep' });
      setPageLoader(false);
    } else {
      setPageLoader(false);
      return enqueueSnackbar('Upload all documents', {
        variant: 'info',
      });
    }
  };

  const handleSave = () => {
    setPageLoader(true);
    let flagFalse = 0;
    if (uploadData[0]?.Submitted_File_Id__c) {
      uploadData.forEach((el) => {
        if (el.required === true) {
          if (!el.contentDocumentId) {
            flagFalse++;
          }
        }
      });
    } else {
      setPageLoader(false);
      return enqueueSnackbar('Please Upload Pitch Deck', { variant: 'error' });
    }

    if (flagFalse === 0) {
      setPageLoader(false);
      return enqueueSnackbar('Saved data successfully', {
        variant: 'success',
      });
    } else {
      setPageLoader(false);
      return enqueueSnackbar('Upload all documents', {
        variant: 'info',
      });
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleFileChange = async (file, data) => {
    setPageLoader(true);
    let mainPayload = {
      application: { ...applicationState?.applicationData?.application },
      attachments: [],
    };

    const fileToBase64 = await toBase64(file);
    let payload = [];
    payload?.push({
      title: data?.Document_Type__c,
      fileName: file.name,
      body: fileToBase64.split(',')[1].toString(),
      applicationId: applicationState?.applicationData?.application?.Id,
      parentId: applicationState?.applicationData?.application?.Id,
      mimeType: file?.type,
      id: data?.Id,
    });

    mainPayload.attachments = payload;
    setPageLoader(true);
    postEventApplication(mainPayload)
      .then((data) => {
        if (data?.data?.status === 'true') {
          applicationDispatch({
            type: 'update',
            payload: { applicationData: data?.data?.result?.data },
          });
          setPageLoader(false);
          setFlag(!flag);
          enqueueSnackbar('Document Uploaded Successfully', { variant: 'success' });
        }
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.status === 413) {
          enqueueSnackbar('Document size limit exceeded.', { variant: 'error' });
        } else {
          enqueueSnackbar('Something went wrong', { variant: 'error' });
        }
        setPageLoader(false);
      });
  };

  const getFileType = (fileType) => {
    const fileTypeArray = fileType?.split(';');
    const returnFileTypes = (type) => {
      switch (type) {
        case 'JPEG':
          return 'image/jpeg';
        case 'JPG':
          return 'image/jpg';
        case 'PNG':
          return 'image/png';
        case 'PDF':
          return 'application/pdf';
      }
    };
    let acceptedFiles = '';
    fileTypeArray?.forEach((el, index) => {
      if (index === 0) {
        acceptedFiles = acceptedFiles.toString() + returnFileTypes(el)?.toString();
      } else {
        acceptedFiles = acceptedFiles.toString() + ',' + returnFileTypes(el)?.toString();
      }
    });
    return acceptedFiles;
  };

  return (
    <React.Fragment>
      {pageLoader && <Loader />}
      <Box
        sx={{
          width: isMobileScreen ? '100%' : '75vw',
          margin: '30px auto 0px auto',
          padding: isMobileScreen ? '20px' : '0px',
          paddingBottom: '32px',
        }}
        component={'div'}
        className="d-flex flex-column"
        gap={'36px'}
      >
        {!isMobileScreen && (
          <Typography color={'#333333'} variant="largemedium">
            Upload Required Documents
          </Typography>
        )}
        <Box
          component={'div'}
          className="d-flex flex-column"
          gap={'24px'}
          sx={{
            height: isMobileScreen ? '55vh' : '37.25vh',
            overflowY: 'auto',
          }}
        >
          {uploadData?.map((el) => {
            return (
              <KenDocumentUpload
                required
                label={el.Document_Type__c}
                recordId={el.Submitted_File_Id__c}
                accept={getFileType(el?.Supported_File_Types__c)}
                onChange={(file) => handleFileChange(file[0], el)}
                acceptedTypes={el?.Supported_File_Types__c?.split(';')}
                fileName={el?.Submitted_File_Name__c}
                handleDownload={handleDownload}
                {...el}
              />
            );
          })}
          <Box
            component={'div'}
            sx={{
              background: '#F0EDF6',
              padding: '12px',
              borderRadius: '12px',
              width: isMobileScreen ? 'auto' : 'max-content',
            }}
            gap={'12px'}
            className="d-flex align-items-center"
          >
            <ErrorIcon sx={{ color: '#8A8A8A', height: '20px', width: '20px' }} />
            <Typography color={'#8A8A8A'} variant={isMobileScreen ? 'extrasmallthin' : 'smallthin'}>
              Follow the In5 <a href="https://infivestoragedev.blob.core.windows.net/infive/Design-Business-Plan-Template.pdf" target='_blank'>Business Plan Template</a> as a guideline; system provides a sample of Infive's Presentation PDF for user reference
            </Typography>
          </Box>
        </Box>
      </Box>
      <KenStepperFooter
        totalSteps={applicationState.totalSteps}
        activeStep={applicationState.activeStep}
        onSave={handleSave}
        onPrev={handlePrev}
        onNext={handleNext}
        applicationStatus={applicationState?.applicationData?.application?.Application_Status__c}
      />
    </React.Fragment>
  );
}
